<template>
  <div class="common_wrap bg_grey color_black relative">

    <!-- // registerType 1app注册 2小游戏注册 -->
    <!-- 非小游戏注册展示用户名，其他不展示 -->
    <div v-if="activityInfo.registerType === 1" class="userName">
      用户名：{{ activityInfo.syUsername }}
    </div>

    <!-- 活动页面 -->
    <div class="page" :style="{ backgroundImage: `url(${activityInfo.image})` }"></div>

    <!-- 参与按钮 -->
    <div class="participatingButton" :style="{ background: isCanParticipation ? '#fe732e' : '#8c8a8c' }" @click="participatingActivity">
      参与
    </div>

    <Popup
      :visible.sync="visible"
      v-bind="feedback"
      :skins="{
        headerBg: '#fe732e'
      }"
    >
      <template>
        <div class="flex_center">
          <div class="giftContent">
            您的专属奖励码：
            <span class="giftCode">
              {{ gitCode }}
            </span>
          </div>
        </div>
        <div v-clipboard="gitCode" class="copyBtn">
          复制
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
import Popup from '@/components/Popup.vue';
import { drawActivityReward, getActivityDetail, bandUserOpenid } from '@/apis/qiweiMiniGame'
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import store from "@/store";
import { storeGet } from "@/utils/localStore"
import { Toast } from 'vant'

export default {
  components: {
    Popup
  },
  mixins: [trackingMixin],
  data () {
    return {
      isLoading: false,
      disabledPull: false,
      hasFetched: false,
      visible: false,

      activity_id: '',
      // registerType 1app注册 2小游戏注册
      activityInfo: {},
      gitCode: '', // 用户满足资格时可领取的礼包码
      activityType: '', // 活动类型 3新用户活动 5降登复登维护  6降充复充维护  9流失召回
      sceneEnum: {
        3: 1,
        5: 2,
        6: 3,
        9: 4,
        14: 14
      }, // 使用场景 1新用户活动  2降登复登维护  3降充复充维护  4流失召回
      uid: '', // 新用户活动 只有活动链接里边的type=3时才会有这个字段值，并且需要绑定用户的openid
      appkey: '',
      sceneType: '', // 活动类型 14 时候存在，接口需要
    }
  },
  computed: {
    // openID和wxappid
    wechatInfo () {
      return {
        openid: store.getters['user/openid'],
        wxappid: storeGet('WX_APP_ID')
        // wxappid: 'wx5e3815b7f3f113b5'
      }
    },
    isCanParticipation () {
      if (this.activityType == 14) {
        return true;
      }
      const { drawStatus = 0, activityStatus } = this.activityInfo
      // 活动已结束的话按钮置灰
      if (activityStatus === 1) return false
      return drawStatus === 0 ? false : true
    },
    feedback () {
      return {
        title: '恭喜获得奖励',
        message: [],
        showConfirmButton: false,
        onSure: () => {},
        onCancel: () => {}
      }
    }
  },
  created () {
    document.title = '加载中'
  },
  async mounted () {
    const params = JSON.parse(localStorage.getItem('wxAuthQuery'))
    const { type, activityId, uid = '', appkey, sceneType } = this.$route.query
    this.activityType = type || params.type
    this.activity_id = activityId || params.activityId
    this.uid = uid || params.uid
    this.appkey = appkey || params.appkey
    this.sceneType = sceneType || params.sceneType
    // 新用户的时候需要绑定openid
    if (this.activityType == 3) {
      await this.wechatBindUserOpenId()
    }
    this.init()
  },
  methods: {
    // 绑定用户openid
    async wechatBindUserOpenId () {
      const params = {
        ...this.wechatInfo,
        activityId: this.activity_id,
        uid: this.uid,
        appkey: this.appkey
      }
      // 如果是null 或者 undefined 的时候, 签名哪里会把这个字段计算进去，但是请求的时候会被过滤掉，后端计算的时候没有这个字段会导致签名失败
      if (![undefined, null].includes(this.sceneType)) {
        params.sceneType = this.sceneType
      }
      await bandUserOpenid(params)
    },
    init () {
      this.getActivityDetailInfo()
    },

    //  获取活动数据信息
    getActivityDetailInfo (isTrack = true) {
      const params = {
        activityId: this.activity_id,
        ...this.wechatInfo,
        type: this.activityType,
        appkey: this.appkey,
      }
      // 如果是null 或者 undefined 的时候, 签名哪里会把这个字段计算进去，但是请求的时候会被过滤掉，后端计算的时候没有这个字段会导致签名失败
      if (![undefined, null].includes(this.sceneType)) {
        params.sceneType = this.sceneType
      }
      return getActivityDetail(params).then(res => {
        this.activityInfo = res.data
        document.title = res.data.name

        // isTrack 是否要上报和进页面提示 
        // 如果是用户第一次进来页面初始化的时候需要提示并上报数据
        if (isTrack) {
          if (res.data.activityStatus === 1) {
            this.$toast(`活动已结束`)
          }
  
          // 埋点上报
          const track_name = res.data.activityStatus === 1 ? EVENT_TYPE_ENUM.enterprise_wx_h5_page_end : EVENT_TYPE_ENUM.enterprise_wx_h5_page_underway
          this.EVENT_TRACKING(
            track_name,
            {
              activity_id: this.activity_id,
              scene: this.sceneEnum[this.activityType],
              button_status: res.data.activityStatus === 1 ? undefined : (this.isCanParticipation ? 2 : 1),
              userId: res.data.uid,
              username: res.data.syUsername
            },
            {}
          )
        }
      }).catch((error) => {
        const { code } = error
        if (code === 1306) {
          this.$toast('请先领取见面礼，再参与此活动。如未找到见面礼链接，请咨询客服领取。')
        }
      })
    },
    // 参与活动领取礼包码
    participatingActivity () {
      if (this.activityType == 14) {
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.enterprise_wx_h5_page_receive_award,
          {
            activity_id: this.activity_id,
            scene: this.sceneEnum[this.activityType],
            userId: this.activityInfo.uid,
            username: this.activityInfo.syUsername
          },
          {}
        )
        window.open('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzk0MzI1NDQzNA==&scene=117#wechat_redirect')
        return;
      }

      const { drawStatus, cdk = '', activityStatus } = this.activityInfo


      // 活动已结束的时候直接提示活动已结束
      if (activityStatus === 1) {
        return this.$toast(`活动已结束`)
      }

      // 不满足领取条件
      if (drawStatus === 0) {
        return Toast({
          message: `${this.activityInfo.msg}`,
          className: 'toastCustomClass'
        })
      }
      // 满足领取条件，但是已经领取过了
      if (drawStatus === 2) {
        this.gitCode = cdk
        this.visible = true
        return
      }
      // 没有活动信息
      if (!this.activityInfo.activityId) return

      const params = {
        ...this.wechatInfo,
        activityId: this.activity_id,
        type: this.activityType,
        appkey: this.appkey,
      }
      drawActivityReward(params).then(res => {
        this.gitCode = res.data.cdk
        this.visible = true
        // 重新获取一下当前用户在当前活动的状态
        this.getActivityDetailInfo(false)
        // 领取奖励埋点上报
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.enterprise_wx_h5_page_receive_award,
          {
            activity_id: this.activity_id,
            scene: this.sceneEnum[this.activityType],
            cdk: res.data.cdk,
            userId: this.activityInfo.uid,
            username: this.activityInfo.syUsername
          },
          {}
        )
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.toastCustomClass {
  word-break: unset !important;;
}
</style>
<style lang="scss" scoped>
.userName {
  width: 100%;
  position: absolute;
  top: 5%;
  left: 2%;
  color: #fff;
  font-size: 17px;
  z-index: 99;
}
.page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  // background-color: #000;
  background-position: center;
}

.participatingButton {
  width: 151px;
  height: 36.5px;
  background: #fe732e;
  border-radius: 18.5px;
  color: #fff;
  font-size: 17px;
  text-align: center;
  line-height: 36.5px;
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
}
.giftContent {
  font-size: 17px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  color: #000;
}
.giftCode {
  color: #ff1b1b;
}
.copyBtn {
  display: inline-block;
  width: 110px;
  height: 35px;
  background: #ff1b1b;
  border-radius: 5.5px;
  font-size: 17px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 35px;
  margin: 30px auto 0;
  display: flex;
  justify-content: center;
}

</style>